<template>
  <BaseDataSelect
    :value.sync="syncValue"
    obj-key="id"
    value-key="id"
    :data-list="shopOptions"
    :placeholder="placeholder"
    :clearable="clearable"
    :multiple="multiple"
    :disabled="disabled"
    :loading="loading"
    v-bind="$attrs"
    @change="$emit('change', $event)"
    @clear="$emit('clear', $event)"
  />
</template>

<script>
import { onMounted, ref } from 'vue'
import { useVModel } from '@vueuse/core'
import BaseDataSelect from './BaseDataSelect.vue'
import { GetShops } from '@/api/shop'

const SHOP_PAGE_LIMIT = 100

let cachedShopOptions = null
let cachedShopOptionsPromise = null

const fetchAllShops = async () => {
  const shops = []
  let start = 0

  while (true) {
    const batch = await GetShops({
      start,
      limit: SHOP_PAGE_LIMIT,
    })

    if (!batch?.length) break

    shops.push(...batch)

    if (batch.length < SHOP_PAGE_LIMIT) break
    start += SHOP_PAGE_LIMIT
  }

  return shops
}

const loadShopOptions = async () => {
  if (cachedShopOptions) return cachedShopOptions
  if (cachedShopOptionsPromise) return await cachedShopOptionsPromise

  cachedShopOptionsPromise = fetchAllShops()

  try {
    cachedShopOptions = await cachedShopOptionsPromise
    return cachedShopOptions
  } finally {
    cachedShopOptionsPromise = null
  }
}

export default {
  name: 'ShopFilterSelect',
  components: {
    BaseDataSelect,
  },
  inheritAttrs: false,
  props: {
    value: [String, Number, Object, Array],
    placeholder: {
      type: String,
      default: '請選擇店家',
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    multiple: Boolean,
    disabled: Boolean,
  },
  emits: ['update:value', 'change', 'clear'],
  setup (props, { emit }) {
    const syncValue = useVModel(props, 'value', emit)
    const loading = ref(false)
    const shopOptions = ref([])

    const initShopOptions = async () => {
      loading.value = true

      try {
        shopOptions.value = await loadShopOptions()
      } catch (error) {
        window.$message?.error(error?.message || error)
      } finally {
        loading.value = false
      }
    }

    onMounted(async () => {
      await initShopOptions()
    })

    return {
      syncValue,
      loading,
      shopOptions,
    }
  },
}
</script>

<style scoped lang="postcss">

</style>
